import { jwtDecode } from 'jwt-decode';

interface AccessToken {
  sub: string;
  'cognito:groups': string[];
  exp: number;
  [key: string]: any;
}

export const isAdmin = (accessToken: string = ""): boolean => {
  try {
    const decoded = jwtDecode<AccessToken>(accessToken);
    return decoded['cognito:groups']?.includes('admin_users') || false;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

export const signOutRedirect = (auth: any) => {
  const clientId = "6ef72kj20grdu8bvk4nn5hn20t";
  const logoutUri = process.env.REACT_APP_COGNITO_LOGOUT_URI || 'https://thefrenchjourney.net/';
  const cognitoDomain = "https://ca-central-15fpjdzdby.auth.ca-central-1.amazoncognito.com";
  auth.removeUser();
  window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
};